<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Report detail</li>
            </ol>
          </div>
          <h4 class="page-title">Report Detail</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Report Detail</h4>
          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="row">
              <div class="form-group" *ngIf="raiseDanger" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                  <ngb-alert type="danger" [dismissible]="false" style="width:100%;" dismissible="true">
                    <strong>Error!</strong> {{danger}}
                  </ngb-alert>
                </div>
              </div>
              <div class="form-group" *ngIf="raiseWarning" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;" dismissible="true">
                  <ngb-alert type="info" [dismissible]="false" style="width:100%;">
                    <strong></strong> {{warning}}
                  </ngb-alert>
                </div>
              </div>
            </div>

            <div class="row form-horizontal">
              <div class="col-md-9 form-horizontal px-3">

                <div class="form-group row border-bottom my-3">
                  <label class="col-3 col-form-label font-weight-bold">Search</label>
                </div>

                <div class="form-group row">
                  <label>
                    <input type="radio" name="search" value="search" (change)="onRadioChange('TerminalId')" />
                    Search by Terminal Id
                  </label>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <label>
                    <input type="radio" name="search" value="search" (change)="onRadioChange('SerialNr')" />
                    Search by Serial number
                  </label>
                </div>

                <div class="form-group row" *ngIf="TerminalIdOption">
                  <div class="col-2">
                    <label class="col-form-label">Terminal Id</label>
                  </div>
                  <div class="col-4">
                    <input class="form-control" id="terminalNumberfc" [formControl]="terminalNumberfc" placeholder="" />
                  </div>
                  <div class="col-6">
                    <button type="submit" class="btn btn-info waves-effect waves-light" (click)="submit()">
                      View
                    </button>
                  </div>
                </div>
                <div class="form-group row" *ngIf="SerialNrOption">
                  <div class="col-2">
                    <label class="col-form-label">Serial number</label>
                  </div>
                  <div class="col-4">
                    <input class="form-control" id="serialNumberfc" [formControl]="serialNumberfc" placeholder="" />
                  </div>
                  <div class="col-6">
                    <button type="submit" class="btn btn-info waves-effect waves-light" (click)="submit()">
                      View
                    </button>
                  </div>
                </div>
                
              </div>

            </div>

            <div class="row form-horizontal">
              <div class="form-group row" *ngIf="raiseNoData">
                <div class="col-md-12 form-horizontal px-3">
                  <ngb-alert [dismissible]="false">
                    <strong>{{noData}}</strong>
                  </ngb-alert>
                </div>
              </div>
            </div>

            <div class='bankTransactions' id="DIV_bankTransactions"></div>

            <div class="row" *ngIf="hasData">
              <div class="col-12">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
                  <thead>
                    <tr>
                      <th>Job</th>
                      <th>Serial</th>
                      <th>Customer</th>
                      <th>Customer Name</th>
                      <th>Stock Code</th>
                      <th>Current Status</th>
                      <th>Scanner</th>
                      <th>Received Operator </th>
                      <th>Received Time</th>
                      <th>Dispatch Note</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let terminal of reportData">
                      <td>{{ terminal.job}}</td> <!-- as Serial-->
                      <td>{{ terminal.serial}}</td>
                      <td>{{ terminal.customer}}</td> <!-- as Customer-->
                      <td>{{ terminal.customerName}}</td> <!-- as CustomerName-->
                      <td>{{ terminal.stockCode}}</td>
                      <td>{{ terminal.currentStatus}}</td>
                      <td>{{ terminal.scanner}}</td>
                      <td>{{ terminal.receivedOperator}}</td>
                      <td>{{ terminal.receivedTime | date}}</td>
                      <td>{{ terminal.dispatchNote}} </td>
                      <td>{{ terminal.status}} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12">
                <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="exportToCSV();"> Export to CSV<i class="mdi mdi-plus"></i> </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div> <!-- end container -->
</div>
